@use "variables" as *;

.description {
  font-size: $fontSize-s;
  font-weight: normal;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  width: 100%;
  text-align: left;
  vertical-align: top;
}

.price {
  font-size: $fontSize-m;
  font-weight: bold;
}

.textStack {
  margin-bottom: $spacing-m;
}
